import React, { Component } from 'react'
import { injectIntl } from 'react-intl'         
import ElaborationType from './ElaborationType'
import { ElaborationOptionsMap } from './CutToSizeMaps'
import Translation from '../global/Translation'
import LocalizedLink from "../global/LocalizedLink";
import ConfigurationFavoriteCallToAction from './configurable-favorites/configuration-favorite-call-to-action/ConfigurationFavoriteCallToAction'
import CustomProductsBannerCallToAction from './custom-products-banner-call-to-action/CustomProductsBannerCallToAction'

class ElaborationTypeSelector extends Component {

    render () {
        const {materials} = this.props

        return (
            <div name="cut_to_size_elaboration_type_selector">
                <div className="row no-gutters">
                    <h2 className="questa-bold title-cts">
                        <Translation id="custom_products" defaultMessage="Custom Products" />
                    </h2>
                </div>
                {
                    materials && (
                        <React.Fragment>
                            <div className="custom-products-block">
                                {
                                    Object.keys(materials).filter(el => el !== 'BUDGET').map(elaboration => {
                                        const option = ElaborationOptionsMap[elaboration]
                                        return (
                                            <div key={`id_${elaboration}`} className="custom-products-block__key">
                                                <LocalizedLink routeId={'ROUTE_CUT_TO_SIZE'} header={true} queryString={`?type=${elaboration.toLowerCase()}`} params={{'outlet':''}} gtmLabel={option.gtmLabel}>
                                                    <ElaborationType
                                                        id={elaboration}
                                                        brands={Object.keys(materials[elaboration])}
                                                        title={this.props.intl.formatMessage(option.name)}
                                                        icon={option.image}
                                                        description={this.props.intl.formatMessage(option.text)}
                                                    />
                                                </LocalizedLink>
                                            </div>
                                        )
                                    })
                                }
                            </div>

                            <div className="cta-grid">
                                <ConfigurationFavoriteCallToAction />
                                <CustomProductsBannerCallToAction hasPreOrder={this.props.hasPreOrder} />
                            </div>
                        </React.Fragment>
                    )
                }
            </div>
        )
    }
}

export default injectIntl(ElaborationTypeSelector)